import React, { useState } from "react";
import { Form, Button, Radio, DatePicker, Card } from "antd";
import moment, { Moment } from "moment";

const { RangePicker } = DatePicker;

interface Props {
  onSubmit: (dates: string[]) => void;
  onlyPast?: boolean;
}

const DateSelectionForm: React.FC<Props> = ({ onSubmit, onlyPast }) => {
  const handleSubmit = (values: { dateRange?: [Moment, Moment] }) => {
    const range = values.dateRange;

    if (!range || !range[0] || !range[1]) {
      onSubmit([]);
      return;
    }

    const [start, end] = range;

    const dates: string[] = [];
    const current = start.clone();

    while (current.isSameOrBefore(end, "day")) {
      dates.push(current.format("YYYY-MM-DD"));
      current.add(1, "day");
    }

    onSubmit(dates);
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Form.Item
        name="dateRange"
        label="Date Range"
        rules={[
          {
            required: true,
            message: "Please select a date range",
          },
        ]}
      >
        <RangePicker
          style={{ width: "100%" }}
          format="YYYY-MM-DD"
          disabledDate={
            onlyPast
              ? (current) => current && current >= moment().startOf("day")
              : undefined
          }
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
};

export default DateSelectionForm;
